export const mapApiGradeToUiGrade = (value: string) =>
  value === '?' ? 'UNKNOWN' : value
